import logoBlue from '../brand/logo-blue.svg'
import logoWhite from '../brand/logo-white.svg'

/**
 * Geo4Logistics brand mark for the authenticated shells (operator + portal),
 * using the real brand assets (design-system/brand/logo-{blue,white}.svg) rather
 * than a tinted monogram. The blue mark reads on light surfaces, the white mark
 * on dark/navy surfaces.
 *
 * - `tone="dark"` (default) sits on an always-navy surface (the sidebar, the auth
 *   brand panel) and renders the white mark directly.
 * - `tone="auto"` follows the page theme — blue in light, white in dark — via the
 *   `.g4-brand-logo` swap in entrypoints/application.css (keyed off
 *   `html[data-theme]`, since the app themes through tokens, not a Tailwind
 *   `dark:` variant).
 *
 * The wordmark text sits beside it, so the image is decorative (`alt=""`).
 */
export default function BrandLogo({
  className,
  tone = 'dark',
}: {
  className?: string
  tone?: 'dark' | 'auto'
}) {
  if (tone === 'dark') {
    return <img src={logoWhite} alt="" aria-hidden="true" className={className} />
  }
  return (
    <span className={`g4-brand-logo ${className ?? ''}`}>
      <img className="g4-logo-light" src={logoBlue} alt="" aria-hidden="true" />
      <img className="g4-logo-dark" src={logoWhite} alt="" aria-hidden="true" />
    </span>
  )
}
